<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("skillProfile.prefixCode") }}</label>
          <input
            v-model="model.prefix_code"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('prefix_code') }"
            :placeholder="$t('skillProfile.prefixCode')"
          />
          <div class="invalid-feedback" v-if="errors.has('prefix_code')">
            {{ errors.first("prefix_code") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("skillProfile.nameKH") }}</label>
          <input
            v-model="model.skill_name_kh"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('skill_name_kh') }"
            :placeholder="$t('skillProfile.nameKH')"
          />
          <div class="invalid-feedback" v-if="errors.has('skill_name_kh')">
            {{ errors.first("skill_name_kh") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("skillProfile.nameEN") }}</label>
          <input
            v-model="model.skill_name_en"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('skill_name_en') }"
            :placeholder="$t('skillProfile.nameEN')"
          />
          <div class="invalid-feedback" v-if="errors.has('skill_name_en')">
            {{ errors.first("skill_name_en") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("skillProfile.sector") }}</label>
          <a-select
            v-model.number.trim="model.sector_profile_id"
            class="tw-w-full"
            :class="{
              'is-invalid': errors.has('sector_profile_id'),
            }"
          >
            <a-select-option
              v-for="(sector, index) in sectors"
              :key="index"
              :value="sector.sector_profile_id"
            >
              {{ sector.sector_name_kh }} | {{ sector.sector_name_en }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('sector_profile_id')">
            {{ errors.first("sector_profile_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <label class="form-col-label control-label col-md-5"></label>
        <div class="col-md-12 tw-space-x-2">
          <input type="checkbox" v-model="model.is_accessor" />
          <label class="form-col-label control-label col-md-5">{{
            $t("skillProfile.isAccessor")
          }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
export default {
  name: "skillForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      sectors: [],
      model: {
        prefix_code: null,
        skill_name_kh: null,
        skill_name_en: null,
        sector_profile_id: null,
        is_accessor: false,
      },
    };
  },
  computed: {
    ...mapState("academic/skillProfile", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    await this.fetchFormViewModel();
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/skillProfile/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/skillProfile/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/skillProfile/update", {
          id: this.edit_data.skill_profile_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearEdit() {
      this.model.prefix_code = null;
      this.model.skill_name_kh = null;
      this.model.skill_name_en = null;
      this.model.sector_profile_id = null;
      this.model.is_accessor = false;
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.skill_profile_id = this.edit_data.skill_profile_id;
        this.model.prefix_code = this.edit_data.prefix_code;
        this.model.skill_name_kh = this.edit_data.skill_name_kh;
        this.model.skill_name_en = this.edit_data.skill_name_en;
        this.model.sector_profile_id = this.edit_data.sector_profile_id;
        this.model.is_accessor = this.edit_data.is_accessor;
      }
    },
    fetchFormViewModel() {
      this.waiting = true;
      this.$store
        .dispatch("academic/skillProfile/getFormViewData")
        .then((response) => {
          this.sectors = response.data.sector;
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>